<mat-form-field class="mxs-textarea"
                *ngIf="!formReadonlyMode"
                [formGroup]="form"
                [ngClass]="{'hidden': hidden}"
                [matTooltip]="getValidationHint() | translate"
                [matTooltipClass]="'mxs-error-ttip'">
    <mat-label>{{getLabel() | translate}}</mat-label>
    <textarea matInput
              [name]="name"
              [errorStateMatcher]=errorService
              [formControlName]="name"
              [readonly]=readonly
              [required]="required"
              [rows]=rows>

    </textarea>
    <mat-hint>{{getHint() | translate}}</mat-hint>
    <mat-error *ngFor="let error of getValidationMessages(true)">
        {{getError(error) | translate}}
    </mat-error>

</mat-form-field>

<mat-list-item class="mxs-readonly mxs-textarea-readonly" *ngIf="formReadonlyMode"
               [ngClass]="{'hidden': hidden}">
    <div class="mxs-readonly_label">{{getLabel() | translate}}</div>
    <div class="mxs-readonly_textarea">
        <div class="mxs-readonly_input">{{getDisplayValue( form.controls[name].value)}}</div>
    </div>
</mat-list-item>
